import React, { useState, useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import FormInput from './../components/forms/FormInput';
import Button from './../components/forms/Button';
import DashAuthWrapper from './../components/DashAuthWrapper';
import { useHistory } from 'react-router-dom';
import { apiInstance } from './../Utils';
import { selectCartTotal, selectCartItemsCount, selectCartItems } from './../redux/Cart/cart.selectors';
import { saveOrderHistory } from './../redux/Orders/orders.actions';
// import { clearCart } from './../redux/Cart/cart.actions';
import { updateUserStart } from './../redux/User/user.actions'
import { createStructuredSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';


const mapState = createStructuredSelector({
	total: selectCartTotal,
	itemCount: selectCartItemsCount,
	cartItems: selectCartItems
});

const mapState2 = ({ user }) => ({
	currentUser: user.currentUser,
	  
});

const PaymentDetails = () => {

	const stripe = useStripe();
  	const elements = useElements();
  	const history = useHistory();
	const { total, itemCount, cartItems } = useSelector(mapState);
	const { currentUser } = useSelector(mapState2);
  	const dispatch = useDispatch();

	const initialAddressState = {
		line1: currentUser.address,
		line2: currentUser.address2,
		city: currentUser.city,
		state: currentUser.state,
		postal_code: currentUser.zip,
	};
	

	const [billingAddress, setBillingAddress] = useState({ ...initialAddressState });
	const [nameOnCard, setNameOnCard] = useState(currentUser.displayName);
	const [shippingAddress, setShippingAddress] = useState({ ...initialAddressState });
  	const [recipientName, setRecipientName] = useState(currentUser.displayName);

	const [sameAddress, setSameAddress] = useState(true)
	const [displayName ] = useState(currentUser.displayName);
	const [address ] = useState(currentUser.address);
	const [address2] = useState(currentUser.address2);
	const [city] = useState(currentUser.city);
	const [state] = useState(currentUser.state);
	const [zip] = useState(currentUser.zip);
	const [phone] = useState(currentUser.phone);
	const [fullAddress] = useState(currentUser.fullAddress);
	const [center] = useState(currentUser.center);
	const [subscribed] = useState(true);
	const [EIN] = useState('NULL')
	const [contactName] = useState('NULL')
	const [contactEmail] = useState('NULL')

	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])


	useEffect(() => {
		if (itemCount < 1) {
			history.push('/dashboard');
			alert("Your purshase was successful!")
			
		}
		// eslint-disable-next-line
	}, [itemCount]);

	const handleShipping = evt => {
		const { name, value } = evt.target;
		setShippingAddress({
		  ...shippingAddress,
		  [name]: value
		});
	  };

	const handleBilling = evt => {
		const { name, value } = evt.target;
		setBillingAddress({
		  ...billingAddress,
		  [name]: value
		});
	}

	const handleFormSubmit = async evt => {
		evt.preventDefault();
		const cardElement = elements.getElement('card');
	
		if (!shippingAddress.line1 || !shippingAddress.city ||
			!shippingAddress.state || !shippingAddress.postal_code || !billingAddress.line1 ||
			!billingAddress.city || !billingAddress.state ||
			!billingAddress.postal_code ||
			!recipientName || !nameOnCard
		) {
		  return;
		}

		if (sameAddress){
			apiInstance.post('/payments/create', {
				amount: total * 100,
				shipping: {
				  name: recipientName,
				  address: {
					...shippingAddress
				  }
				}
				
			  }).then(({ data: clientSecret }) => {
		  
				stripe.createPaymentMethod({
				  type: 'card',
				  card: cardElement,
				  billing_details: {
					name: recipientName,
					address: {
					  ...shippingAddress
					}
				  }
				  
				}).then(({ paymentMethod }) => {
		  
				  stripe.confirmCardPayment(clientSecret, {
					payment_method: paymentMethod.id
				  })
				  .then(({ paymentIntent }) => {
	  
					  const configOrder = {
						  orderTotal: total,
						  orderItems: cartItems.map(item => {
							const { documentID, productName,
							  productPrice, productCategory } = item;
			  
							return {
							  documentID,
							  productName,
							  productPrice,
							  productCategory
							};
						  })
					  }
	  
	  
					  dispatch(updateUserStart({
							EIN,
							contactName,
							contactEmail,
						  displayName,
						  address,
						  address2,
						  city,
						  state,
						  zip,
						  phone,
						  subscribed,
						  fullAddress,
						  center
					  }))
					  dispatch(
						  saveOrderHistory(configOrder)
					  );
					  
					  
			  
	  
				  });
		  
				})
		  
		  
			  });

		}else{
			apiInstance.post('/payments/create', {
				amount: total * 100,
				shipping: {
				  name: recipientName,
				  address: {
					...shippingAddress
				  }
				}
				
			  }).then(({ data: clientSecret }) => {
		  
				stripe.createPaymentMethod({
				  type: 'card',
				  card: cardElement,
				  billing_details: {
					name: nameOnCard,
					address: {
					  ...billingAddress
					}
				  }
				  
				}).then(({ paymentMethod }) => {
		  
				  stripe.confirmCardPayment(clientSecret, {
					payment_method: paymentMethod.id
				  })
				  .then(({ paymentIntent }) => {
	  
					  const configOrder = {
						  orderTotal: total,
						  orderItems: cartItems.map(item => {
							const { documentID, productName,
							  productPrice, productCategory } = item;
			  
							return {
							  documentID,
							  productName,
							  productPrice,
							  productCategory
							};
						  })
					  }
	  
	  
					  dispatch(updateUserStart({
							EIN,
							contactName,
							contactEmail,
						  displayName,
						  address,
						  address2,
						  city,
						  state,
						  zip,
						  phone,
						  subscribed,
						  fullAddress,
						  center
					  }))
					  dispatch(
						  saveOrderHistory(configOrder)
					  );
					  
					  
			  
	  
				  });
		  
				})
		  
		  
			  });

		}
	
		


		
		
	  };


	const configCardElement = {
		iconStyle: 'solid',
		style: {
		  base: {
			fontSize: '16px'
		  }
		},
		hidePostalCode: true
	};

	const congfigAuthWrapper = {
		headline: 'Payment Details'
	}
	
	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
			<form className="py-5 mx-auto" onSubmit={handleFormSubmit}>
			<h2 className="text-left group-label">
					Shipping Address
				</h2>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Recipient Name"
						name="recipientName"
						handleChange={evt => setRecipientName(evt.target.value)}
						value={recipientName}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Address"
						name="line1"
						handleChange={evt => handleShipping(evt)}
						value={shippingAddress.line1}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						placeholder="Address 2"
						name="line2"
						handleChange={evt => handleShipping(evt)}
						value={shippingAddress.line2}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="City"
						name="city"
						handleChange={evt => handleShipping(evt)}
						value={shippingAddress.city}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="State"
						name="state"
						handleChange={evt => handleShipping(evt)}
						value={shippingAddress.state}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Zip Code"
						name="postal_code"
						handleChange={evt => handleShipping(evt)}
						value={shippingAddress.postal_code}
						type="number"
						className="form-control"
					/>
				</div>

				<div className="row flex justify-content-center">
					{sameAddress &&
					<label htmlFor="sameAddress" className="rounded-full">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 svg" viewBox="0 0 20 20" fill="currentColor">
							<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
						</svg>
					</label>
					}
					{!sameAddress &&
					<label htmlFor="sameAddress" className="rounded-full">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
						</svg>
					</label>
					}
					<button id="sameAddress" type="button" className='' onClick={() => setSameAddress(!sameAddress)} >
					Use Same Address For Billing
						
					</button>
				</div>
				
				
				{!sameAddress && (
					<>
				<h2 className="text-left mt-5 group-label">
					Billing Address
				</h2>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Name on Card"
						name="nameOnCard"
						handleChange={evt => setNameOnCard(evt.target.value)}
						value={nameOnCard}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Address"
						name="line1"
						handleChange={evt => handleBilling(evt)}
						value={billingAddress.line1}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						placeholder="Address 2"
						name="line2"
						handleChange={evt => handleBilling(evt)}
						value={billingAddress.line2}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="City"
						name="city"
						handleChange={evt => handleBilling(evt)}
						value={billingAddress.city}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="State"
						name="state"
						handleChange={evt => handleBilling(evt)}
						value={billingAddress.state}
						type="text"
						className="form-control"
					/>
				</div>
				<div className="form-group text-left">
					<FormInput
						required
						placeholder="Zip Code"
						name="postal_code"
						handleChange={evt => handleBilling(evt)}
						value={billingAddress.postal_code}
						type="number"
						className="form-control"
					/>
				</div>
				</>
				)}




				<div className="mt-5 mb-5">
					<h2 className="text-left group-label">
						Card Details
					</h2>
					<div className=" card">
						<CardElement  className="p-2"
							options={configCardElement}
						/>
					</div>
		
				</div>
				<h4 className="mb-3 text-left">
					Total: ${total}
				</h4>
				<Button type="submit">
					Pay Now
				</Button>

			</form>
		</DashAuthWrapper>
	)
}

export default PaymentDetails;
